import React from "react";
import { LOAI_DIEM_TABS, getDiemColor } from "./NhapDiem";

const NhapDiemMobile = ({ selectedLop, hocSinh, diemData, changedItems, activeTab, setActiveTab, canEdit, isAdmin, getDiemTB, updateDiem, setHasChanges, setChangedItems, setDiemData, LIMIT }) => {
  return (
    <>
      {/* TABS */}
      <div className="flex gap-2 overflow-x-auto hide-scrollbar pb-1">
        {LOAI_DIEM_TABS.map(tab => (
          <button key={tab.key} onClick={() => setActiveTab(tab.key)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-all ${activeTab === tab.key ? `${tab.bg} ${tab.color} shadow-sm` : 'bg-surface text-on-surface-variant border border-outline-variant'}`}>
            <span className="material-symbols-outlined text-[18px]">{tab.icon}</span>{tab.label}
          </button>
        ))}
      </div>

      {/* CARD LIST */}
      <div className="space-y-2">
        {!selectedLop ? (
          <div className="text-center py-12 text-on-surface-variant"><span className="material-symbols-outlined text-[48px]">school</span><p className="mt-2">{isAdmin ? 'Chọn lớp để xem điểm' : 'Bạn chưa có lớp'}</p></div>
        ) : hocSinh.length === 0 ? (
          <div className="text-center py-12 text-on-surface-variant"><span className="material-symbols-outlined text-[48px]">search_off</span><p className="mt-2">Không tìm thấy học sinh</p></div>
        ) : (
          hocSinh.map(hs => {
            const diemTB = getDiemTB(hs.id);
            const tabInfo = LOAI_DIEM_TABS.find(t => t.key === activeTab);
            return (
              <div key={hs.id} className={`bg-surface rounded-xl p-4 shadow-sm border ${changedItems.has(hs.id) ? 'border-yellow-400 bg-yellow-50/50' : 'border-outline-variant'}`}>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-11 h-11 rounded-full bg-primary-fixed flex items-center justify-center text-primary font-bold text-sm">{hs.hoTen?.charAt(0)}</div>
                  <div className="flex-1 min-w-0">
                    <p className="text-caption text-on-surface-variant">{hs.tenThanh || 'Chưa có'}</p>
                    <p className="text-body-md font-semibold truncate">{hs.hoTen}</p>
                  </div>
                  <div className="flex flex-col items-end">
                    {diemTB !== '—' ? <><span className={`text-xl font-bold ${getDiemColor(parseFloat(diemTB))}`}>{diemTB}</span><span className="text-[10px] text-on-surface-variant">ĐTB môn</span></> : <span className="text-caption text-on-surface-variant/60">Chưa đủ</span>}
                  </div>
                </div>
                <div className="border-t border-outline-variant/50 my-2" />
                <div className="flex items-center gap-2">
                  <span className="text-caption text-on-surface-variant font-medium min-w-[60px]">{tabInfo?.label}:</span>
                  <div className="flex items-center gap-1.5 flex-1">
                    {(diemData[hs.id]?.[activeTab] || []).map((val, i) => (
                      <input key={i} type="number" min="0" max="10" step="0.5" value={val || ''} onChange={e => updateDiem(hs.id, activeTab, i, e.target.value)} disabled={!canEdit}
                        className={`w-14 h-11 text-center font-bold text-body-lg border rounded-xl outline-none ${canEdit ? 'bg-surface-container-low border-outline-variant focus:border-primary' : 'bg-gray-100'} ${val > 0 ? getDiemColor(val) : 'text-on-surface-variant'}`} placeholder="—" />
                    ))}
                    {canEdit && (diemData[hs.id]?.[activeTab] || []).length < LIMIT[activeTab] && (
                      <button onClick={() => { setHasChanges(true); setChangedItems(prev => new Set([...prev, hs.id])); setDiemData(prev => { const nd = JSON.parse(JSON.stringify(prev)); if (!nd[hs.id]) nd[hs.id] = { mieng: [], '15phut': [], '1tiet': [], hocKy: [] }; nd[hs.id][activeTab].push(0); return nd; }); }}
                        className="w-11 h-11 rounded-xl bg-primary-container text-on-primary-container flex items-center justify-center font-bold text-lg">+</button>
                    )}
                  </div>
                </div>
                {diemTB !== '—' && (
                  <div className="flex gap-2 mt-2 pt-2 border-t border-outline-variant/30">
                    {['mieng', '15phut', '1tiet', 'hocKy'].map(loai => {
                      const vals = (diemData[hs.id]?.[loai] || []).filter(v => v > 0);
                      const label = loai === 'mieng' ? 'M' : loai === '15phut' ? '15\'' : loai === '1tiet' ? '1T' : 'HK';
                      let d = '—';
                      if (vals.length > 0) d = loai === 'mieng' ? (vals.reduce((a,b)=>a+b,0)/vals.length).toFixed(1) : vals[0];
                      return <div key={loai} className="flex-1 text-center"><span className="text-[10px] text-on-surface-variant block">{label}</span><span className={`text-sm font-bold ${vals.length > 0 ? getDiemColor(parseFloat(d)) : 'text-on-surface-variant/40'}`}>{d}</span></div>;
                    })}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default NhapDiemMobile;